import axios from 'axios';
import { config } from '../config/environment';

const STUDENT_API_BASE_URL = config.coreApiUrl;
const API_TIMEOUT = 30000;

export const studentApi = axios.create({
  baseURL: STUDENT_API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

if (config.features.debug) {
  console.log('🎓 Student API Service initialized with base URL:', STUDENT_API_BASE_URL);
}

// Request interceptor: auth token + X-Guest-Id for guest API calls
studentApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // For guest API calls (except POST /api/guest/session), send X-Guest-Id from localStorage
    // so guest endpoints always receive the header even if the caller omitted it
    const url = config.url ?? '';
    if (url.includes('/api/guest') && !(config.method === 'post' && url.endsWith('/session'))) {
      const guestId = localStorage.getItem('guestId');
      if (guestId) {
        config.headers['X-Guest-Id'] = guestId;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
studentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const token = localStorage.getItem('authToken');
      
      // Only redirect if we have a token and we're not already on login page
      if (token && currentPath !== '/login' && !currentPath.startsWith('/login')) {
        const preventRedirect = error.config?.preventAuthRedirect === true;
        
        if (!preventRedirect) {
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          window.dispatchEvent(new Event('userLogout'));
          window.location.href = '/login?authFailed=true';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default studentApi;
